<template>
  <component :is="isComponent" />
</template>
<script>
import { mapGetters } from 'vuex'
import StorageOrder from './storage-order'
import SupplyOrder from './supply-order'

export default {
  name: 'OrderList',
  components: { StorageOrder, SupplyOrder },
  computed: {
    ...mapGetters(['userType']),
    isComponent() {
      let component = ''
      const userType = this.userType
      console.log(userType)

      if (userType === '1' || userType === '2') {
        component = 'SupplyOrder'
      } else if (userType === '3' || userType === '4') {
        component = 'StorageOrder'
      }
      return component
    }
  }

}
</script>
